import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'attachmentName',
  standalone: true
})
export class AttachmentNamePipe implements PipeTransform {
  constructor() {
  }

  public transform(v: any, key?: string | null): string {
    return (key ? v[key] : v?.originalName) || '-';
  }
}
